export const COMBOBOX_DIVIDER_ITEM = "combobox-divider";
export const COMBOBOX_CATEGORY_ITEM = "combobox-category";
export const COMBOBOX_OPTION_ITEM = "combobox-option";
